import { HttpError } from '@euler/lib/request/HttpError';

/** What to tell the user when an attachment cannot be fetched. */
export function attachmentErrorText(error: unknown): string {
  // Uploaded sheets are kept for 90 days, then removed from storage.
  return error instanceof HttpError && error.code === 'resource_not_found'
    ? '这个文件已经过期了，方便的话请重新上传一次～'
    : '抱歉，文件暂时打不开，请稍后再试一次';
}
